import { INamespace, TAccessLevel } from '@/types';
import { IBaseResponse, fetchWrapper, IResponseError } from './apiBase';
import { BASE_API_URL } from '@/config/environment';

interface INamespaceResponse extends IBaseResponse {
  namespace?: INamespace;
  access_level?: TAccessLevel;
  error?: IResponseError;
}

export interface IReferralStatus {
  can_refer: boolean;
  message: string;
}

const mapAccessLevelToNamespace = (response: INamespaceResponse): INamespaceResponse => {
  const initialNamespace = response.namespace;
  const namespaceObject = {
    ...initialNamespace?.object,
    access_level: initialNamespace?.access_level,
    entityType: initialNamespace?.type,
  };
  const namespace = initialNamespace ? ({ ...initialNamespace, object: namespaceObject } as INamespace) : undefined;
  return {
    ...response,
    namespace: namespace,
  };
};

export const fetchNamespace = async ({
  namespace,
  token,
}: {
  namespace: string;
  token?: string;
}): Promise<INamespaceResponse> => {
  const targetUrl = `${BASE_API_URL}/namespace/${namespace}`;

  const data = await fetchWrapper({
    resourceName: 'namespace',
    targetUrl,
    authToken: token,
    resourceContext: { namespace },
    supressNotFoundErrors: true,
  });
  return mapAccessLevelToNamespace(data);
};

export const fetchReferralStatus = async ({ namespace }: { namespace: string }): Promise<IReferralStatus> => {
  const targetUrl = `${BASE_API_URL}/namespace/${namespace}/referral_status`;

  const data = await fetchWrapper({
    resourceName: 'namespace',
    targetUrl,
  });

  return data.referral_status;
};
